import { Box } from "@mui/material";
import React from "react";

interface IVerticalContainerProps {
    before?: React.ReactNode;
    main?: React.ReactNode; // expands to fill available space
    children?: React.ReactNode; // expands to fill available space
    after?: React.ReactNode;
    disableMainInitialHeight?: boolean;
    width?: string;
    minHeight?: string;
};

export const VerticalContainer = (props: IVerticalContainerProps) => (
    <Box sx={{ height: "100%", minHeight: props.minHeight, display: "flex", flexDirection: "column", width: props.width }}>
        {!!props.before &&
            <Box>
                {props.before}
            </Box>
        }
        {!!props.main &&
            <Box sx={{ flexGrow: 1, height: props.disableMainInitialHeight ? "auto" : 0 }}>
                {props.main}
            </Box>
        }
        {!!props.children && React.Children.toArray(props.children).map((main, index) => (
            <Box key={index} sx={{ flexGrow: 1, height: props.disableMainInitialHeight ? "auto" : 0 }}>
                {main}
            </Box>))
        }
        {!!props.after &&
            <Box>
                {props.after}
            </Box>
        }
    </Box>
);
